import React from 'react';
import { useSelector } from 'react-redux';
import isDesktop from 'store/app/selector/isDesktop';
import { BasketItem } from '../BasketMain/types';
import styles from './BasketItemPreview.module.scss';

interface BasketItemPreviewProps {
  thumbnailUrl: string;
}

const BasketItemPreview: React.FC<BasketItemPreviewProps> = ({ thumbnailUrl }) => {
  const isDesktopDevice = useSelector(isDesktop);

  const previewWidth = isDesktopDevice ? 188 : 96;
  const previewHeight = isDesktopDevice ? 188 : 96;

  return (
    <div className={styles.preview}>
      <img src={thumbnailUrl} alt="Order item thumbnail" width={previewWidth} height={previewHeight} />
    </div>
  );
};

export default BasketItemPreview;
